import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Style } from 'react-style-tag';
import dih from '../../helpers/defaultImages.helper';
import ModuleService from '../../services/module.service';
import UserService from '../../services/user.service';
import Logo from '../../components/login/logo';

const linkComp = ({ location }) => link => (
  <li key={link.path}>
    <a
      target="_blank"
      href={link.path}
      className={`three-dots ${link.path === location.pathname ? 'active' : ''}`}
    >{link.name}
    </a>
  </li>
);

const Header = ({ t,
  user,
  links,
  refs,
  showMenu,
  location,
  menuIcon,
  pageTitle,
  getAvatar,
  toggleMenu,
  customLinks,
  youtube,
  vimeo,
  pageSubTitle,
  backgroundPage,
  enableCoverColor,
  countUnreadMessage,
  generateBackgroundImg,
}) => (
  <React.Fragment>
    <Style>
      {enableCoverColor ? '' :
        `main.main .header-cov .banner.bannerother.tc {
          background: none;
      }`
      }
    </Style>
    <section className="header">
      <div className="container">
        <div className="headertop boxs pdlr forflex pdlrzero">
          <div className="left">
            <div className="leftinner boxs">
              <h6 className="logo">
                <Logo />
              </h6>
            </div>
          </div>
          <div className="right">
            <div className="rightinner boxs">
              {!!user && (
                <ul className="profilemenu">
                  <li className="forproimg">
                    <a href="#profile">
                      <img
                        src={getAvatar(user, 150, 150, true)}
                        alt="subscriber"
                        className="img-responsive"
                        onError={(e) => { e.target.src = UserService.defaultAvatar; }}
                      />
                    </a>
                  </li>
                  <li className="onhoverprofilemenu">
                    <ul className="boxs ">
                      <li><Link to="/profile">{t('My profile')}</Link></li>
                      <li><Link to="/logout">{t('Log Out')}</Link></li>
                    </ul>
                  </li>
                </ul>
              )}
              {!user && (
                <ul className="guest-menu">
                  <li>
                    <Link to="/login">
                      {t('Login')}
                    </Link>
                  </li>
                </ul>
              )}
            </div>
            <button
              className={menuIcon}
              type="button"
              onClick={e => toggleMenu(e)}
              ref={r => refs.store('menu', r)}
            >
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
          </div>
        </div>
      </div>
      <div
        className={`sidenav${showMenu ? ' sidenav_act' : ''}`}
        id="mySidenav"
        ref={r => refs.store('sidenav', r)}
      >
        <Logo />
        <div className="side_inner boxs">
          <ul>
            {!!user && (
              <React.Fragment>
                <li><Link to="/profile" className="fontmulisemi" onClick={e => toggleMenu(e)}>{t('My profile')}</Link></li>
                <li><Link to="/logout" className="fontmulisemi" onClick={e => toggleMenu(e)}>{t('Log Out')}</Link></li>
              </React.Fragment>
            )}
            {!user && (
              <React.Fragment>
                <li><Link to="/login" className="fontmulisemi" onClick={e => toggleMenu(e)}>{t('login')}</Link></li>
              </React.Fragment>
            )}
            {links.map((link) => {
              switch (link.moduleType) {
                case ModuleService.TYPE_LINK:
                  return customLinks.map(linkComp({ location }));
                case ModuleService.TYPE_YOUTUBE:
                  return youtube.map(linkComp({ location }));
                case ModuleService.TYPE_VIMEO:
                  return vimeo.map(linkComp({ location }));
                default:
                  return (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className={`three-dots ${link.path === location.pathname ? 'active' : ''}`}
                        onClick={e => toggleMenu(e)}
                      >{link.name}
                        {link.module === ModuleService.TYPE_MESSAGE && countUnreadMessage ?
                          <span className="msgnumber">{countUnreadMessage}</span> : ''}
                      </Link>
                    </li>);
              }
            })}
          </ul>
        </div>
      </div>
    </section>
    <div
      className="header-cov"
      style={{
          background: generateBackgroundImg() }}
    >
      <div className={backgroundPage || dih.defaultColorBack}>
        <section className="banner bannerother tc transbox" />
        <div className="container">
          <div className="bannerinner boxs">
            <div className="banneroabs boxs">
              <h2>{ pageTitle }
                {pageSubTitle && <span className="sub-title"> {pageSubTitle}</span>}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

Header.propTypes = {
  getAvatar: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  customLinks: PropTypes.array.isRequired,
  youtube: PropTypes.array.isRequired,
  links: PropTypes.array.isRequired,
  showMenu: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
  menuIcon: PropTypes.string.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  pageSubTitle: PropTypes.string,
  backgroundPage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default Header;



// WEBPACK FOOTER //
// ./src/containers/header/Header.js